import { useState, useEffect, useRef } from 'react'
import classnames from 'classnames/bind'
import { isEmpty } from 'lodash-es'

// Components
import NotificationItem from './components/NotificationItem'

// Types
import { NotificationItemType } from '@/types/room'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface NotificationProps {
  className?: string
  notificationList: NotificationItemType[]
}

const Notification = (props: NotificationProps) => {
  const { className, notificationList } = props

  const [currentIndex, setCurrentIndex] = useState(1)
  const [isSliding, setIsSliding] = useState(false)

  const notificationListRef: any = useRef([])

  const currentNotification = notificationList[currentIndex - 1]

  const isItemSlided = notificationListRef.current.includes(currentIndex)

  useEffect(() => {
    if (isItemSlided) return

    if (!isSliding && !isItemSlided && currentIndex <= notificationList?.length) {
      setIsSliding(true)
    }
  }, [currentIndex, isSliding, notificationList, isItemSlided])

  const handleAnimationEnd = () => {
    notificationListRef.current.push(currentIndex)

    setIsSliding(false)

    setCurrentIndex((prev) => prev + 1)
  }

  return (
    <div className={cx('notification', className)}>
      {!isEmpty(notificationList) && isSliding && (
        <NotificationItem
          className={cx('notification-item', { isShow: isSliding })}
          {...currentNotification}
          handleAnimationEnd={handleAnimationEnd}
        />
      )}
    </div>
  )
}

export default Notification
